module.exports = __webpack_public_path__ + "img/vn.0a64acda.svg";